export default {
    LOGIN: "登录",
    LOGIN_USERNAME: "用户名",
    LOGIN_PASSWORD: "密码",
    LOGIN_FORGOT_PASSWORD: "忘记密码?",
    LOGIN_LOGINING: "登录中",
    LOGIN_PLS_INPUT_USERNAME: "请输入用户名",
    LOGIN_PLS_INPUT_PASSWORD: "请输入密码",
    LOGIN_USERNAME_OR_PASSWORD_INCORRECT: "用户名或密码不正确",

    NO_LOGIN_PERMISSIONS: "当前用户没有登录权限",

    SETTING_CHANGE_PASSWORD: "更改密码",
    SETTING_CHANGE_AVATAR: "更换头像",
    SETTING_LOGOUT: "注销",

    HOMEPAGE: "首页",
    PRODUCTLIST: "产品价格查询",
    KHGL: "客户管理",
    BUSINESSMANAGEMENT: "商务管理",
    NONSTANDARDAUDIT: "非标评审",
    ORDERMANAGEMENT: "订单管理",
    TECHNICALSUPPORT: "技术支持",
    SALESSERVICE:"售后服务",
    FINANCIALMANAGEMENT: "财务管理",
    ORDERORSHIPMENT:"下单/发货预测",
    MAINTENCEORDER:"维修申请订单",
    QUERYLIST:"维修订单",
    PARTSSTANDARD:"配件/标准订单申请报表查询",
    ORDERSTATUSQUERY:"配件/标准订单完工入库情况查询",
    DEALERORDER:"标准/配件订单下单申请",
    KEHU:"客户",
    CONTACT:"联系人",
    LEAD:"线索报备",
    LEADREGINSTER:"线索跟进任务",
    STANDARDORDER:"标准订单",
    PARTSORDER:"配件订单",
    OPPORTUNITY:"商机管理",
    PROJECTCREDIT:"项目授权申请",
    SERVICETICKET:"服务单",
    PARTSBORROW:"配件借用",
    APPLICATION:"开票申请",
    DELIVERYNOTE:"开票申请首页",
    INVOICEAPPLICATIONLIST:"开票申请列表",
    INVOICEDELIVERYLIST:"发票签收",
    INVOICEDEALERLIST:"发票",
    //SHIPMENT:"出货申请",
    RECEPTION:"客户接待",
    APPLYSERVICE:"工程/售后服务申请",
    ORDERMAINTAIN:"维修申请订单",
    CROSSPROJECTITEM:"跨区域工程项目",
    TICKETSUM:"经销商可开票汇总",
    ACHIEVEMENTAPPLY:"跨区域服务费结算任务",
    PAYMENTAPPLY:"付款申请",
    PJTITEM:"工程项目",
    QUALITY:"品质反馈",
    PROJECTSUPPORT:"项目技术支持任务",
    EXPACHIEVEMENTAPPLY:"跨区域业绩划拨利润",
    SERVICESUPPORT:"按次服务支持任务",
    ACCOUNTPROJECT:"客户项目",
    EQUIPMENTRECEIVE:"仓库收货",
    PROJECTLIST:"项目设备管理",
    DEALERCHARGE:"待请款金额",
    DEALERLETTER:"函件管理",
    // 首页问候语
    GOODMORNING: "早上好",
    GOODAFTERNOON: "中午好",
    GOODNIGHT: "晚上好",

    More: "更多",
    Notice:"公告标题",
    NOTICELIST: "公告通知",
    NoticePublishTime: "发布时间",
    DataDownload: "资料下载 ",
    FileName: "文件名 ",
    MesContent:"消息内容",
    FormCode:"单号",
    SendTime:"发送时间",

    DealerRights:"经销商权益",

    Select: "请选择",
    SelectDate: "选择日期",
    QuickSearch: "快速搜索",


    BUTTON_ADD: "新增",
    BUTTON_EDIT: "编辑",
    BUTTON_DELETE: "删除",
    BUTTON_EXPORT: "导出",
    BUTTON_IMPORT: "导入",
    BUTTON_SEARCH: "查询",
    BUTTON_MORE: "更多",
    BUTTON_DOWNLOAD: "下载",

    BUTTON_SAVE: "保存",
    BUTTON_SUBMIT: "提交",
    BUTTON_RETURN: "返回",
    BUTTON_MAPDISPATCH: "地图派工",
    BUTTON_MORESCREEN: "更多筛选",

    BUTTON_RESET: "重置",
    BUTTON_BATCHADD: "批量添加",
    BUTTON_WITHDRAW: "撤回",
    BUTTON_APPROVALPROGRESS: "审批进度",
    BUTTON_PRINT: "打印",
    BUTTON_DETERMINE: "确定",
    BUTTON_CANCEL: "取消",
    BUTTON_REASSIGN: "改派",
    BUTTON_UPLOAD: "上传",
    BUTTON_ENABLE: "启用",
    BUTTON_DISABLE: "停用",
    BUTTON_SYNCHRONISE: "同步",
    BUTTON_CLOSE: "关闭",
    BUTTON_RESETPASS: "重置密码",


    Flow:"签核流程",
    ChooseSignFlow: "选择签核流程 (下拉框中可能存在多个可选项目,请注意选择合适的流程)",
    ChooseSignUser: "选择签核用户 (下拉框中可能存在多个可选人员,请注意选择合适的下一级呈递人)",
    ServiceSignStep1: "服务单签核步骤1",
    RecordOfApproval: "审批记录",
    History: "历史记录",

    BUTTON_REMOVE:'移除值',
    BUTTON_ConAndSend:"确认并寄送发票",
    BUTTON_ASSIGN:"派工",
    BUTTON_SIGNANDCON:"签收确认",
    BUTTON_REPLY:"回复",
    BUTTON_SENDCONFIRM:"发运确认",

    BUTTON_SENDVCODE:"发送验证码",
    LOGIN_VCODE:"验证码",
    LOGIN_PLS_INPUT_VCODE: "请输入验证码",
    CREDITINFOLIST:"授信申请",
    DEALERBILLLIST:"账单管理",
    DELAYLIST:"账单延期申请",

    ACCOUNTINFO:"账户信息",
    CHECKBILL:"对账单",
    ZHANGHUZICHAN:'账户资产',
    HANJIAN:'函件管理',
    KEHULIEBIAO:'客户列表',
    XIADAN:'下单申请',
    GONGCHENG:'跨区工程申请',
    ZHICHI:'技术支持服务',
    SHOUHOU:'跨区售后申请',
    SHOUXIN:'授信申请',
    SERVICEORDERFORM:'服务订单',
    PURCHASEORDERFORM:'采购订单',
    SHIPMENT:'出货信息',
    FWRY2:'服务人员'
};



// WEBPACK FOOTER //
// ./src/components/locale/lang/zh-CN.js